import React from "react";
import "./NewsletterSection.css";

// Import required components
import { Heading, Newsletter } from "../../../components";



const NewsletterSection = () => {
  return (
    <section className="newsletter-subscribe">
      <div className="content">

        <Heading title={"Subscribe To Our Newsletter"} linear /> {/* Section heading with linear style */}
        <p>Subscribe to receive the latest insights on cutting-edge AI technologies, product updates, case studies, and how our solutions can transform your business.</p>

        <Newsletter variant='default' idPrefix='1' /> {/* Newsletter subscription form */}

      </div>
    </section>
  );
};

export default NewsletterSection;